import axios from 'axios';

const createInstallmentApi = async (token, values, edit = false, url) => {
  try {
    const res = await axios.post(url, values, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'applications/json',
        Authorization: 'Bearer ' + token,
        lang: 'ar'
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default createInstallmentApi;
